import { Box } from "@mui/material"
import { registerTab, Tabs } from "lib/@components/tabs"
import { References } from "../references"
import { OverwriteGroupTasks } from "./overwrite-group-tasks"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { isGroupValid } from "../lib/is-group-valid"

export function OverwriteGroup() {
    const { group } = useBoundContext()
    const isValid = isGroupValid(group)
    registerTab({
        tab: "overwritegroup",
        id: "tasks",
        title: <Box>Tasks</Box>,
        content: <OverwriteGroupTasks />,
    })
    registerTab({
        tab: "overwritegroup",
        id: "references",
        title: <Box>References</Box>,
        content: <References />,
        tabProps: { disabled: !isValid },
    })

    return <Tabs id="overwritegroup" panelHolder={<Box my={2} />} tabHolder={<Box />} />
}
